// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_container__TD7d_","bg":"modal_bg__3lKTq","modal":"modal_modal__1ow5F"};